import Vue, { PropType, VNode } from 'vue'
import { INotificationItem } from './NotificationItemBase'
import NotificationProposalObservation from './Proposal/NotificationProposalObservation'
import NotificationProposalStatusChange from './Proposal/NotificationProposalStatusChanged'

import './Notification.scss'
import { VAvatar, VBtn, VCol, VIcon, VRow, VTooltip } from 'vuetify/lib'
import { notificationDateTime } from '@/utils/date'
import { NotificationService } from '@/services'
import { ROUTERS } from '@/router/ROUTERS'
import NotificationPreAnalisysObservation from './PreAnalisys/NotificationPreAnalisysObservation'
import { ERROR_TEXTS } from '@/constants/ErrorTexts'
import { APP_SET_ERROR } from '@/store/MUTATIONS-TYPES'

export const Notification = Vue.component('Notification', {
	name: 'Notification',
	props: {
		notification: { type: Object as PropType<INotificationItem>, required: true }
	},

	computed: {
		notificationComponent(): VNode {
			const onEvents = {
				'notification:clicked': () => this.readNotification()
			}

			switch (this.notification.category) {
				case 'PreAnalise':
					switch (this.notification.topic) {
						case 'Observacao':
							return <NotificationPreAnalisysObservation on={onEvents} notification={this.notification} />
					}
				case 'Proposta':
					switch (this.notification.topic) {
						case 'Status':
							return <NotificationProposalStatusChange on={onEvents} notification={this.notification} />
						case 'Observacao':
							return <NotificationProposalObservation on={onEvents} notification={this.notification} />
					}
			}
		},

		notificationIcon(): string {
			switch (this.notification.category) {
				case 'PreAnalise':
					switch (this.notification.topic) {
						case 'Observacao':
							return 'comment'
					}
				case 'Proposta':
					switch (this.notification.topic) {
						case 'Status':
							return 'sync_alt'
						case 'Observacao':
							return 'comment'
					}
			}
		},

		isUnread(): boolean {
			return !this.notification.readAt
		},

		proposalTab(): string {
			switch (this.notification.topic) {
				case 'Status':
					return '1'
				case 'Observacao':
					return '3'
			}
		}
	},

	methods: {
		readNotification() {
			try {
				if (this.notification.readAt == null) NotificationService.setAsRead(this.notification.id)
			} catch (err) {
				const { commit } = this.$store
				commit(APP_SET_ERROR, {
					silent: false,
					errorMessage: ERROR_TEXTS.ERROR_API_SET_NOTIFICATION_READ,
					errorException: err,
					extras: {
						method: 'Notification->ReadNotification()'
					}
				})
			}
		}
	},

	render() {
		let onClickAction = {
			click: () => {}
		}

		if (this.notification.category == 'PreAnalise')
			onClickAction = {
				click: () => {
					this.$router.push({
						name: ROUTERS.CREDITO_IMOBILIARIO.PRE_ANALISE.DETALHES,
						params: { preanaliseId: this.notification.proposalId.toString() }
					})

					this.$emit('notification:clicked', this.notification.id)
				}
			}

		if (this.notification.category == 'Proposta')
			onClickAction = {
				click: () => {
					this.$router.push({
						name: ROUTERS.PROPOSTAS.PROPOSTA,
						params: { propostaId: this.notification.proposalId.toString(), tab: this.proposalTab }
					})

					this.$emit('notification:clicked', this.notification.id)
				}
			}

		return (
			<div class="notification-item pa-2" onClick={() => onClickAction.click()}>
				{this.isUnread && (
					<VTooltip
						bottom
						dark
						color="primary"
						scopedSlots={{
							activator: ({ on }: { on: any }) => (
								<VBtn class="notification-item-unread-btn" on={on} onClick={() => this.readNotification()} icon text>
									<div></div>
								</VBtn>
							)
						}}
					>
						Marcar como lido
					</VTooltip>
				)}

				<VRow no-gutters>
					<div class="py-3 mr-2">
						<VAvatar color="#f1f1f1">
							<VIcon class="material-icons-outlined">{this.notificationIcon}</VIcon>
						</VAvatar>
					</div>

					<VCol>
						<div>
							{this.notificationComponent}
							<div class="mt-1 notification-item-time">{notificationDateTime(this.notification.createdAt)}</div>
						</div>
					</VCol>
				</VRow>
			</div>
		)
	}
})
